<div class="edit-page-root-container ads-settings-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" (click)="navBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="title">
        <ng-container *ngIf="adsInfo === 0">New Ads Content</ng-container>
        <ng-container *ngIf="adsInfo > 0">Editing {{ adTitle }}</ng-container>
      </div>
      <div class="action-btn-container">
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="update()">UPDATE</button>
      </div>
    </div>

    <div class="page-details">
      <div class="ads-settings-main">
        <app-ads-shop-selection #shopSelection></app-ads-shop-selection>
        <app-ads-file-upload #fileUpload [selectedShops]="shopSelection.selectedShops"
          [adId]="adsInfo"></app-ads-file-upload>
      </div>
    </div>
  </div>
</div>